import React, { useState, useEffect, useRef } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDInput from "components/MDInput";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
//import ListItemText from '@mui/material/ListItemText';
import Select from "@mui/material/Select";
import axios from "axios";
import { CircularProgress } from "@mui/material";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDEditor from "components/MDEditor";
import FormField from "layouts/pages/account/components/FormField";
import MDDatePicker from "components/MDDatePicker";
import MDTypography from "components/MDTypography";
import Autocomplete from "@mui/material/Autocomplete";
import MapSelect from "./map";
import { fetchFormFields } from "./data/fetchFormFields";
import config from "../../../config";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;

const Events = () => {
  const [eventType, setEventType] = useState("");
  const [category, setCategory] = useState("");
  const [island, setIsland] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [position, setPosition] = useState(null); //[0,0]
  const [description, setDescription] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [formOptions, setFormOptions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [fileName, setFileName] = useState(""); // State to store the file name
  const fileInputRef = useRef(null);

  useEffect(() => {
    const loadFields = async () => {
      try {
        const { data } = await fetchFormFields();
        console.log("form fields data:", data);
        setFormOptions(data); // categories, subCategories, typeOfEvents, etc.
      } catch (err) {
        console.error(err);
        setError("Αποτυχία φόρτωσης πεδίων φόρμας.");
      } finally {
        setLoading(false);
      }
    };
    loadFields();
  }, []);

  const handleInputChange = (field, value) => {
    console.log("handleInputChange:", field, value);
  const fieldToErrorMap = {
    type_event: "eventType",
    category: "category",
    island: "island"
  };

  const errorKey = fieldToErrorMap[field];
  if (errorKey) {
    setFormErrors((prev) => ({ ...prev, [errorKey]: undefined }));
  }
    const id = value?.id ?? "";
    if (field === "type_event") {
      setEventType(id);
    } else if (field === "category") {
      setCategory(id);
    } else if (field === "subcategory") {
      setSubcategory(id);
    } else if (field === "description") {
      requestAnimationFrame(() => {
        setDescription(value || "");
      });
    }
    else if (field === "island") {
      setIsland(id);
    }
    else {
      console.error("Unknown field:", field);
    }
  };

  const handleDateChange = (date, field) => {
    if (!date || !date[0]) return;
    const isoDate = date[0].toISOString();

    const fieldToErrorMap = {
      start: "startDate",
      end: "endDate",
    };

    const errorKey = fieldToErrorMap[field];
    if (errorKey) {
      setFormErrors((prev) => ({ ...prev, [errorKey]: undefined }));
    }

    if (field === "start") {
      setStartDate(isoDate);
    } else if (field === "end") {
      setEndDate(isoDate);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setFileName(file.name);

    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result.trim();
      const lines = text.split("\n");

      // Parse headers and values
      const headers = lines[0].split(",").map((h) => h.trim());
      const values = lines[1].split(",").map((v) => v.trim());

      const data = {};
      headers.forEach((key, index) => {
        data[key] = values[index];
      });

      console.log("data", data);

      // Set each field
      const matchType = formOptions.typeOfEvents.find(
        (item) => item.name === data.type
      );
      if (matchType) setEventType(matchType.id);

      const matchCategory = formOptions.categories.find(
        (item) => item.name === data.category
      );
      if (matchCategory) setCategory(matchCategory.id);

      const matchIsland = formOptions.islands.find(
        (item) => item.name === data.island
      );
      if (matchIsland) setIsland(matchIsland.id);

      
  

      const matchSub = formOptions.subCategories.find(
        (item) => item.name === data.subcategory
      );
      if (matchSub) setSubcategory(matchSub.id);

      if (data.startDate) {
        const date = new Date(data.startDate);
        if (!isNaN(date)) setStartDate(date.toISOString());
      }

      if (data.endDate) {
        const date = new Date(data.endDate);
        if (!isNaN(date)) setEndDate(date.toISOString());
      }

      if (data.lng && data.lat) {
        const lng = Number(data.lng);
        const lat = Number(data.lat);
        if (!isNaN(lng) && !isNaN(lat)) {
          setPosition([lng, lat]);
        }
      }

      requestAnimationFrame(() => setDescription(data.description || ""));
    };

    reader.readAsText(file);
  };

  const validateForm = () => {
    const errors = {};

    if (!eventType) errors.eventType = "Το πεδίο είναι υποχρεωτικό.";
    if (!category) errors.category = "Το πεδίο είναι υποχρεωτικό.";
    if (!startDate) errors.startDate = "Το πεδίο είναι υποχρεωτικό.";
    if (!position || position.length !== 2)
      errors.position = "Η θέση συμβάντος είναι υποχρεωτική.";
    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      if (end <= start) {
        errors.endDate = "Η ημερομηνία λήξης πρέπει να είναι μετά την έναρξη.";
      }
    }
    return errors;
  };

  const handleImportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSubmit = async () => {
    const errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    setFormErrors({}); // Clear previous errors

    let finalEndDate = endDate;

    if (!endDate && startDate) {
      const start = new Date(startDate);
      const end = new Date(start.getTime() + 60 * 60 * 1000); // Add 1 hour
      finalEndDate = end.toISOString();
      setEndDate(finalEndDate); // Optional: update UI if needed
    }

    const eventData = {
      type_of_event: eventType,
      category: category,
      island: island,
      subcategory: subcategory || null, // 👈 convert "" to null
      valid_from: startDate,
      valid_until: finalEndDate, // Always send a valid end time
      geometry: {
        type: "Point",
        coordinates: [position], // must be [ [lng, lat] ]
      },
      description: description,
      status: 1,
      verification: 1,
      source_id: 3,
      link_id: [],
      from_node: "",
      to_node: "",
    };

    console.log("eventData", eventData);

    try {
      const response = await axios.post(`${API_URL}/events`, eventData, {
        headers: {
          "X-API-Key": API_TOKEN,
          "Content-Type": "application/json",
        },
      });

      if (response?.status === 201 || response?.status === 200) {
        alert("Η καταχώρηση συμβάντος έγινε επιτυχώς");

        // full page reload
      //  window.location.reload();
      }
    } catch (error) {
      console.error("Error inserting event:", error);
      alert("Αποτυχία καταχώρησης συμβάντος");
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <MDBox mt={4} p={3}>
          <CircularProgress />
        </MDBox>
      </DashboardLayout>
    );
  }

  if (error) {
    return (
      <DashboardLayout>
        <MDBox mt={4} p={3}>
          <MDTypography color="error">{error}</MDTypography>
        </MDBox>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <MDBox mt={4} p={0}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={5}>
            <Card id="accident-form" sx={{ overflow: "visible" }}>
              <MDBox p={3}>
                <MDTypography variant="h5">Εισαγωγή Συμβάντων</MDTypography>
              </MDBox>
              <MDBox compoent="form" pb={3} px={3}>
                <Grid container spacing={3}>
                {/* island */}
                  <Grid item xs={12}>
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      Νησί
                    </MDTypography>
                    <Autocomplete
                      value={
                        formOptions.islands.find(
                          (vl) => vl.id === island
                        ) || null
                      }
                      options={formOptions.islands}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, selectedOption) =>
                        handleInputChange("island", selectedOption)
                      }
                      renderInput={(params) => (
                        <MDInput {...params} variant="standard" />
                      )}
                    />
                    {formErrors.island && (
                      <MDTypography variant="caption" color="error">
                        {formErrors.island}
                      </MDTypography>
                    )}
                  </Grid>

                  {/* Type of Event */}
                  <Grid item xs={12}>
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      Τύπος Συμβάντος
                    </MDTypography>

                    <Autocomplete
                      value={
                        formOptions.typeOfEvents.find(
                          (vl) => vl.id === eventType
                        ) || null
                      }
                      options={formOptions.typeOfEvents}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, selectedOption) =>
                        handleInputChange("type_event", selectedOption)
                      }
                      renderInput={(params) => (
                        <MDInput {...params} variant="standard" />
                      )}
                    />
                    {formErrors.eventType && (
                      <MDTypography variant="caption" color="error">
                        {formErrors.eventType}
                      </MDTypography>
                    )}
                  </Grid>

                  {/* Category */}
                  <Grid item xs={12}>
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      Κατηγορία Συμβάντος
                    </MDTypography>
                    <Autocomplete
                      value={
                        formOptions.categories.find(
                          (vl) => vl.id === category
                        ) || null
                      }
                      options={formOptions.categories}
                      getOptionLabel={(option) => option.name}
                      onChange={(e, selectedOption) =>
                        handleInputChange("category", selectedOption)
                      }
                      renderInput={(params) => (
                        <MDInput {...params} variant="standard" />
                      )}
                    />
                    {formErrors.category && (
                      <MDTypography variant="caption" color="error">
                        {formErrors.category}
                      </MDTypography>
                    )}
                  </Grid>

                  {/* Subcategory */}
                  {category &&
                    formOptions.subCategories.some(
                      (sc) => sc.category_id === Number(category)
                    ) && (
                      <Grid item xs={12}>
                        <MDTypography
                          component="label"
                          variant="button"
                          fontWeight="regular"
                          color="text"
                        >
                          Υποκατηγορία Συμβάντος
                        </MDTypography>
                        <Autocomplete
                          value={
                            formOptions.subCategories.find(
                              (sc) => sc.id === subcategory
                            ) || null
                          }
                          options={formOptions.subCategories.filter(
                            (sc) => sc.category_id === Number(category)
                          )}
                          getOptionLabel={(option) => option.name}
                          onChange={(e, selectedOption) =>
                            handleInputChange("subcategory", selectedOption)
                          }
                          renderInput={(params) => (
                            <MDInput {...params} variant="standard" />
                          )}
                        />
                      </Grid>
                    )}

                  {/* Date pick */}
                  <Grid item xs={12} sm={12} container direction="column">
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      Ημερομηνία Έναρξης
                    </MDTypography>
                    <MDDatePicker
                      input={{ placeholder: "dd/mm/yyyy HH:mm" }}
                      value={startDate ? new Date(startDate) : null}
                      options={{
                        enableTime: true,
                        dateFormat: "d/m/Y H:i",
                        altFormat: "d/m/Y H:i",
                        time_24hr: true,
                      }}
                      onChange={(date) => handleDateChange(date, "start")}
                    />
                    {formErrors.startDate && (
                      <MDTypography variant="caption" color="error">
                        {formErrors.startDate}
                      </MDTypography>
                    )}
                  </Grid>

                  <Grid item xs={12} sm={12} container direction="column">
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      Ημερομηνία Λήξης
                    </MDTypography>
                    <MDDatePicker
                      input={{ placeholder: "dd/mm/yyyy HH:mm" }}
                      value={endDate ? new Date(endDate) : null}
                      options={{
                        enableTime: true,
                        dateFormat: "d/m/Y H:i",
                        altFormat: "d/m/Y H:i",
                        time_24hr: true,
                      }}
                      onChange={(date) => handleDateChange(date, "end")}
                    />
                    {formErrors.endDate && (
                      <MDTypography variant="caption" color="error">
                        {formErrors.endDate}
                      </MDTypography>
                    )}
                  </Grid>

                  {/* Position */}
                  <Grid item xs={12} sm={12} container direction="column">
                    <MDTypography
                      component="label"
                      variant="button"
                      fontWeight="regular"
                      color="text"
                    >
                      Θέση Συμβάντος
                    </MDTypography>
                    {!position && (
                      <MDTypography
                        component="label"
                        variant="button"
                        fontWeight="regular"
                        color="text"
                      >
                        Επέλεξε Θέση στο Χάρτη
                      </MDTypography>
                    )}
                    {position && (
                      <MDTypography
                        component="label"
                        variant="button"
                        fontWeight="regular"
                        color="text"
                      >
                        Lat: {position[0]}
                      </MDTypography>
                    )}
                    {position && (
                      <MDTypography
                        component="label"
                        variant="button"
                        fontWeight="regular"
                        color="text"
                      >
                        Long: {position[1]}
                      </MDTypography>
                    )}
                    {formErrors.position && (
                      <MDTypography variant="caption" color="error">
                        {formErrors.position}
                      </MDTypography>
                    )}
                  </Grid>

                  {/* Description */}
                  <Grid item xs={12} sm={12}>
                    <MDBox
                      mb={1}
                      ml={0.5}
                      lineHeight={0}
                      display="inline-block"
                    >
                      <MDTypography
                        component="label"
                        variant="button"
                        fontWeight="regular"
                        color="text"
                      >
                        Περιγραφή&nbsp;&nbsp;
                      </MDTypography>
                    </MDBox>
                    <MDEditor
                      value={description || ""} // Prevents undefined issues
                      onChange={(e) => handleInputChange("description", e)}
                    />
                  </Grid>
                  {/* Submit */}
                  <Grid mt={3} item xs={12} sm={12}>
                    <MDBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <MDBox display="flex" alignItems="center">
                        <input
                          type="file"
                          accept=".csv"
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          style={{ display: "none" }}
                        />
                        <MDButton
                          variant="contained"
                          color="warning"
                          onClick={handleImportClick}
                          sx={{
                            "&.MuiButton-contained": {
                              textTransform: "capitalize !important",
                            },
                          }}
                          disabled
                        >
                          Εισαγωγή CSV
                        </MDButton>
                        <span style={{ marginLeft: "10px" }}>{fileName}</span>
                      </MDBox>

                      <MDButton
                        variant="gradient"
                        color="info"
                        onClick={handleSubmit}
                        sx={{
                          "&.MuiButton-contained": {
                            textTransform: "capitalize !important",
                          },
                        }}
                      >
                        Καταχώρηση
                      </MDButton>
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} lg={7}>
            <div className="mapContainer100">
              <MapSelect
                selectedPoint={position}
                setSelectedPoint={(point) => {
                  setFormErrors((prev) => ({ ...prev, position: undefined }));
                  setPosition(point);
                }}
              />
            </div>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default Events;
